export default {
  groupName: 'ford-lincoln-growth',
  appName: 'Lincoln Focus Audience',
  isAuto: true,
  baseRoute: '/ford-lincoln-growth',
  image: 'ford_lincoln.png',
  description:
    'Lincoln - US Focus Audience Advertising Dashboard'
}



// WEBPACK FOOTER //
// ./src/app/configuration/FordLincolnGrowth/config/main.js